import { FunnelModule } from '@/components/modules/Funnel/Funnel';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

import { DYNAMIC_PAGE_PATHS } from '../../shared/pathRoutes';

export const PAGE_FUNNEL: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.FUNNEL,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'FUNNEL',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <FunnelModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
